<template>
<div class="my-message">
    <!-- 页面内加载遮罩 -->
    <div v-if="isSending" class="sending-overlay">
        <div class="sending-content">
            <i class="el-icon-loading"></i>
            <p>{{ sendingText }}</p>
            <el-button 
                type="danger" 
                size="small" 
                @click="handleCancelSending"
                :disabled="shouldStopSending"
            >
                {{ shouldStopSending ? '正在取消...' : '✕ 取消发送' }}
            </el-button>
        </div>
    </div>
    <!-- 联系人选择弹窗 -->
    <el-dialog
        title="选择联系人"
        :visible.sync="contactSelectorVisible"
        width="600px"
        :before-close="handleContactSelectorClose"
    >
        <div class="contact-selector">
            <!-- 好友分组 -->
            <el-collapse v-model="activeCollapseNames">
                <el-collapse-item name="friends">
                    <template slot="title">
                        <el-checkbox 
                            v-model="selectAllFriends" 
                            @change="handleSelectAllFriends"
                        >
                            好友 ({{ friendContacts.length }})
                        </el-checkbox>
                    </template>
                    <div class="contact-list">
                        <el-checkbox-group v-model="selectedFriends">
                            <el-checkbox 
                                v-for="contact in friendContacts" 
                                :key="contact.wxid" 
                                :label="contact.wxid"
                                class="contact-item"
                            >
                                <div class="contact-info">
                                    <el-avatar 
                                        :size="30" 
                                        :src="contact.smallHeadImgUrl" 
                                        shape="square"
                                    ></el-avatar>
                                    <span class="contact-name">{{ contact.nickName || contact.nickname || contact.wxid }}</span>
                                </div>
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-collapse-item>
                
                <!-- 群聊分组 -->

                <el-collapse-item name="groups">
                    <template slot="title">
                        <el-checkbox 
                            v-model="selectAllGroups" 
                            @change="handleSelectAllGroups"
                        >
                            群聊 ({{ groupContacts.length }})
                        </el-checkbox>
                    </template>
                    <div class="contact-list">
                        <el-checkbox-group v-model="selectedGroups">
                            <el-checkbox 
                                v-for="contact in groupContacts" 
                                :key="contact.wxid" 
                                :label="contact.wxid"
                                class="contact-item"
                            >
                                <div class="contact-info">
                                    <el-avatar 
                                        :size="30" 
                                        :src="contact.smallHeadImgUrl" 
                                        shape="square"
                                    ></el-avatar>
                                    <span class="contact-name">{{ contact.remark || contact.nickName || contact.wxid }}</span>
                                </div>
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-collapse-item>
                
            </el-collapse>
        </div>
        
        <span slot="footer" class="dialog-footer">
            <el-button @click="contactSelectorVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmContactSelection">确 定</el-button>
        </span>
    </el-dialog>
    
    <template v-if="$store.state.member_id=='1'||$store.state.storePath.includes('my/message')">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="消息编辑" name="first">
                <el-form ref="form" :model="messageInfo" label-width="80px" center>
                    <el-form-item label="文本消息" >
                        <el-input type="textarea" v-model="messageInfo.content"></el-input>
                    </el-form-item>
                    
                    <el-form-item label="图片消息" >
                        <el-upload
                            class="upload-demo"
                            drag
                            :action="$axios.defaults.baseURL+'index.php?act=upload&op=image'"
                            :data="{store_id:this.$store.state.store_id}"
                            :headers="{'token':$store.state.token}"
                            name="image"
                            list-type="picture"
                            :on-success="upImgSuccess"
                            :limit="9"
                            :on-remove="(file)=>{fileDel(file,'imgList')}"
                            multiple
                            >
                             <!-- multiple -->
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件</div>
                        </el-upload>
                    </el-form-item>
                    <!-- <el-input v-model="messageInfo.fileName"></el-input> -->
                    <template >
                        <el-form-item label="上传文件" >
                            <el-upload
                                :action="$axios.defaults.baseURL+'index.php?act=upload&op=image'"
                                :data="{store_id:this.$store.state.store_id}"
                                :headers="{'token':$store.state.token}"
                                name="image"
                                :on-success="upFileSuccess"
                                :limit="9"
                                :on-remove="(file)=>{fileDel(file,'fileList')}"
                                multiple
                                >
                                <el-button size="mini" type="primary">点击上传</el-button>
                            </el-upload>
                        </el-form-item>
                      
                    </template>
                    <el-form-item>
                        <div style="text-align: center;">
                            <!-- <el-button>取消</el-button> -->
                            <el-button type="primary" size="mini" @click="showContactSelector">发送消息</el-button>

                        </div>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="消息历史" name="second">
                <div class="his-list">
                    <div class="msg-item"  v-for="(item,index) of messageList " :key="index">
            
                        <div class="item-top">
                            <div class="tit">
                                {{ item.msg_type}}
                            </div>
                            <div class="time">
                                {{$hnwTools.formatDateTime(item.add_time,'ymd')}}
                            </div>
                        </div>
                        <div class="item-body">
                           
                            <a :href="item.msg_cont" v-if=" item.msg_type=='文件消息'" :download="item.msg_extend"> {{ item.msg_extend }} </a>
                            <el-image
                                v-else-if=" item.msg_type=='图片消息'"
                                :style="{width:70+'px',height:70+'px'}"
                                :src="item.msg_cont"
                                :preview-src-list="[item.msg_cont]"
                            ></el-image>
                            <span v-else>{{ item.msg_cont }} </span>
                        </div>
                        
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>

    </template>
</div>
</template>

<script>
/**
 * 将字符串转换为 URL 安全的 Base64 编码（适配阿里云水印等场景）
 * @param {string} str - 需要编码的字符串（支持中文、英文、Emoji等）
 * @returns {string} - URL 安全的 Base64 字符串
 */
function encodeUrlSafeBase64(str) {
  if (!str) return '';

  // 1. 解决中文/特殊字符乱码问题：使用 TextEncoder 将字符串转为 UTF-8 字节流
  const encoder = new TextEncoder();
  const uint8Array = encoder.encode(str);
  
  // 2. 将字节流转换为二进制字符串，供 btoa 使用
  // btoa 原生只支持 ASCII 字符，直接传中文会报错，所以需要先转成字节对应的单字符
  let binaryString = '';
  uint8Array.forEach(byte => {
    binaryString += String.fromCharCode(byte);
  });

  // 3. 进行标准的 Base64 编码
  let base64 = btoa(binaryString);

  // 4. 转换为 URL 安全格式（阿里云要求的标准操作）
  return base64
    .replace(/\+/g, '-')  // 将加号 + 替换为短划线 -
    .replace(/\//g, '_')  // 将正斜线 / 替换为下划线 _
    .replace(/=+$/, '');  // 去掉尾部的等号 =
}
export default {
    data(){
        return{

            messageInfo:{
                content:"",
                file:"",
                type:"文本",
                fileName:""
            },

            activeName:"first",
            messageList:[],
            fileList:[],
            imgList:[],
            // 新增：存储发送消息的返回信息，用于撤回功能
            sentMessages: [],
            // 新增：控制发送中断标志
            shouldStopSending: false,
            // 新增：页面内加载状态
            isSending: false,
            sendingText: '正在发送中...',
            
            // 联系人选择相关数据
            contactSelectorVisible: false,
            activeCollapseNames: ['friends', 'groups'], // 默认展开所有分组
            allContacts: [], // 所有联系人信息
            friendContacts: [], // 好友联系人
            groupContacts: [], // 群聊联系人
            selectedFriends: [], // 选中的好友
            selectedGroups: [], // 选中的群聊
            selectAllFriends: true, // 是否全选好友
            selectAllGroups: true, // 是否全选群聊
            filteredFriends: [], // 过滤后的好友列表
            filteredChatrooms: [] // 过滤后的群聊列表
        }
    },
    methods:{
        
        // 显示联系人选择弹窗
        async showContactSelector() {
            // 显示加载状态
            this.isSending = true
            this.sendingText = '正在获取联系人信息...'
            
            try {
                // 获取联系人列表
                let res = await this.$apiGewe.getUserList({})
                
                // 功能1：过滤好友和群聊
                this.filteredFriends = res.data.friends.filter(friend => {
                    return friend.startsWith('wxid_')
                })
                
                this.filteredChatrooms = res.data.chatrooms.slice(1) // 过滤掉第一个群
                
                console.log('🔍 过滤后的私聊好友：', this.filteredFriends)
                console.log('🔍 过滤后的群聊：', this.filteredChatrooms)
                
                // 分批获取联系人详细信息
                await this.fetchContactDetails()
                
                // 获取上次选择的联系人
                await this.getLastSelectedContacts()
                
                // 显示联系人选择弹窗
                this.contactSelectorVisible = true
            } catch (error) {
                console.error('获取联系人信息失败：', error)
                this.$erMsg('获取联系人信息失败')
            } finally {
                // 关闭加载状态
                this.isSending = false
            }
        },
        
        // 获取上次选择的联系人
        async getLastSelectedContacts() {
            try {
                // 获取上次选择的好友
                const lastSelectedFriendsRes = await this.$api.getCommData({
                    k: 'last_mine_wxids'
                });
                
                // 获取上次选择的群聊
                const lastSelectedGroupsRes = await this.$api.getCommData({
                    k: 'last_room_wxids'
                });
                console.log("lastSelectedFriendsRes",lastSelectedFriendsRes);
                
                // 如果有上次选择的联系人，则使用上次的选择，不再默认全选
                if (lastSelectedFriendsRes && lastSelectedFriendsRes.length>0) {
                    // 过滤掉已经不存在的联系人
                    this.selectedFriends = lastSelectedFriendsRes[0].value.split(",")
                } else {
                    // 如果没有上次选择的记录，则默认不选中任何好友
                    this.selectedFriends = [];
                }
                
                if (lastSelectedGroupsRes && lastSelectedGroupsRes.length>0) {
                    // 过滤掉已经不存在的群聊
                    this.selectedGroups = lastSelectedGroupsRes[0].value.split(',')
                } else {
                    // 如果没有上次选择的记录，则默认不选中任何群聊
                    this.selectedGroups = [];
                }
                
                // 更新全选状态
                this.selectAllFriends = this.selectedFriends.length === this.friendContacts.length && this.friendContacts.length > 0;
                this.selectAllGroups = this.selectedGroups.length === this.groupContacts.length && this.groupContacts.length > 0;
            } catch (error) {
                console.error('获取上次选择的联系人失败：', error);
                // 如果获取失败，则默认不选中任何联系人
                this.selectedFriends = [];
                this.selectedGroups = [];
                this.selectAllFriends = false;
                this.selectAllGroups = false;
            }
        },
        
        // 保存当前选择的联系人
        async saveCurrentSelectedContacts() {
            try {
                // 保存当前选择的好友
                await this.$api.setCommData({
                    k: 'last_mine_wxids',
                    v: this.selectedFriends.join()
                });
                
                // 保存当前选择的群聊
                await this.$api.setCommData({
                    k: 'last_room_wxids',
                    v: this.selectedGroups.join()
                });
            } catch (error) {
                console.error('保存当前选择的联系人失败：', error);
            }
        },
        
        // 分批获取联系人详细信息
        async fetchContactDetails() {
            // 获取好友详细信息
            this.friendContacts = await this.fetchBatchContactDetails(this.filteredFriends, '好友')
            
            // 获取群聊详细信息
            this.groupContacts = await this.fetchBatchContactDetails(this.filteredChatrooms, '群聊')
            console.log("this.friendContacts",this.friendContacts);
            console.log("this.groupContacts",this.groupContacts);
        },
        
        // 分批获取联系人详细信息（每批不超过20个）
        async fetchBatchContactDetails(wxids, type) {
            let contacts = []
            const batchSize = 20 // 每批最多20
            
            for (let i = 0; i < wxids.length; i += batchSize) {
                const batch = wxids.slice(i, i + batchSize)
                try {
                    const res = await this.$apiGewe.getDetailInfo({
                        wxids: batch
                    })
                    
                    if (res && res.data) {
                        // 处理返回的数据，添加类型标识
                        // console.log("res",res.dat);
                        contacts = res.data.map(contact => ({
                            ...contact,
                            type: 'friend',
                            wxid: contact.userName
                        }))
                        // const batchContacts = Object.keys(res.data).map(wxid => ({
                        //     wxid,
                        //     ...res.data[wxid],
                        //     type
                        // }))
                        // contacts.push(...batchContacts)
                    }
                } catch (error) {
                    console.error(`获取${type}详细信息失败：`, error)
                }
            }
            
            return contacts
        },
        
        // 全选/取消全选好友
        handleSelectAllFriends(val) {
            if (val) {
                this.selectedFriends = this.friendContacts.map(contact => contact.wxid)
            } else {
                this.selectedFriends = []
            }
        },
        
        // 全选/取消全选群聊
        handleSelectAllGroups(val) {
            if (val) {
                this.selectedGroups = this.groupContacts.map(contact => contact.wxid)
            } else {
                this.selectedGroups = []
            }
        },
        
        // 确认联系人选择
        confirmContactSelection() {
            // 保存当前选择的联系人
            this.saveCurrentSelectedContacts();
            
            // 关闭弹窗
            this.contactSelectorVisible = false
            
            // 开始发送消息
            this.sendMessagesToSelectedContacts()
        },
        
        // 发送消息到选中的联系人
        async sendMessagesToSelectedContacts() {
            // 显示页面内加载状态
            this.isSending = true
            this.sendingText = '正在发送中...'
            
            // 清空之前的发送记录和中断标志
            this.sentMessages = []
            this.shouldStopSending = false
            
            const sendMessagesToContacts = async (contacts) =>{
                // 随机延迟函数：延迟 3~5 秒
                const randomDelay = () => {
                    const delay = Math.floor(Math.random() * 3000) + 3000; // 3000ms ~ 5000ms
                    return new Promise(resolve => setTimeout(resolve, delay));
                };
                const randomDelay1000 = () => {
                    const delay = Math.floor(Math.random() * 1000) + 2000; 
                    return new Promise(resolve => setTimeout(resolve, delay));
                };

                // 获取第一个联系人作为基准
                const firstContact = contacts.length > 0 ? contacts[0] : null;

                // 遍历每个联系人
                for (const contact of contacts) {
                    // 检查是否需要中断
                    if (this.shouldStopSending) {
                        console.log('🚫 用户取消发送，中断后续消息发送')
                        break
                    }
                    
                    console.log(`📌 开始处理联系人: ${contact.wxid}`);
                    try {
                        // 检查是否需要中断
                        if (this.shouldStopSending) {
                            console.log('🚫 用户取消发送，中断当前联系人消息发送')
                            break
                        }
                        
                        // 判断是否是第一个联系人
                        const isFristContact = firstContact && contact.wxid === firstContact.wxid;
                        
                        // === 第一个接口：sendMsg ===
                        if(this.messageInfo.content){

                            let msgResult = await this.$apiGewe.sendMsg({
                                toWxid: contact.wxid,
                                ...this.messageInfo
                            });
                            console.log(`✅ ${contact.wxid} - sendMsg 发送成功`);
                            
                            // 存储发送结果用于撤回
                            if(msgResult && msgResult.data) {
                                this.sentMessages.push({
                                    ...msgResult.data,
                                    type: 'text'
                                })
                            }
                            
                            await randomDelay1000(); // 延迟 3~5 秒
                            
                            // 只有发送给第一个联系人的消息才会被保留到历史记录中
                            if (isFristContact) {
                                await this.$api.sendSysMsg({
                                    msg_type:"文字消息",
                                    msg_cont:this.messageInfo.content
                                })
                            }
                        }

                        // === 第二个接口：sendFileMsg ===
                        if(this.fileList.length>0){
                            for (let index = 0; index < this.fileList.length; index++) {
                                // 检查是否需要中断
                                if (this.shouldStopSending) {
                                    console.log('🚫 用户取消发送，中断文件消息发送')
                                    break
                                }
                                const fileItem = this.fileList[index];
                                let fileResult = await this.$apiGewe.sendFileMsg({
                                    toWxid: contact.wxid,
                                    fileUrl:fileItem.fileUrl,
                                    fileName:fileItem.fileName
                                });
                                console.log(`✅ ${contact.wxid} - sendFileMsg 发送成功`);
                                
                                // 存储发送结果用于撤回
                                if(fileResult && fileResult.data) {
                                    this.sentMessages.push({
                                        ...fileResult.data,
                                        type: 'file'
                                    })
                                }
                                
                                // 只有发送给第一个联系人的消息才会被保留到历史记录中
                                if (isFristContact) {
                                    await this.$api.sendSysMsg({
                                        msg_type:"文件消息",
                                        msg_cont:fileItem.fileUrl,
                                        msg_extend:fileItem.fileName
                                    })
                                }
                                await randomDelay1000(); // 延迟 3~5 秒
                            }
                        }

                        // === 第三个接口：sendImgMsg ===
                        if(this.imgList.length>0){
                            for (let index = 0; index < this.imgList.length; index++) {
                                // 检查是否需要中断
                                if (this.shouldStopSending) {
                                    console.log('🚫 用户取消发送，中断图片消息发送')
                                    break
                                }
                                const fileItem = this.imgList[index];
                                console.log("contact",contact);
                                // let imgResult = await this.$apiGewe.sendImgMsg({
                                    //     toWxid: contact.wxid,
                                    //     imgUrl:fileItem.url 
                                    // });
                                    // contact.remark || contact.nickName
                                let base64Text = encodeUrlSafeBase64(contact.remark || contact.nickName);
                                let watermarkEss = ""
                                // watermarkEss = `?x-oss-process=image/watermark,text_${base64Text},color_FFFFFF,,size_26,rotate_45,fill_1,g_center,shadow_20,padx_26,pady_26`
                                console.log(`✅ ${contact.wxid} - sendImgMsg 发送成功`);
                                console.log("base64Text",fileItem.url + watermarkEss)
                                 let imgResult = await this.$apiGewe.sendImgMsg({
                                    toWxid: contact.wxid,
                                    imgUrl:fileItem.url + watermarkEss
                                });
                                // 存储发送结果用于撤回
                                if(imgResult && imgResult.data) {
                                    this.sentMessages.push({
                                        ...imgResult.data,
                                        type: 'image'
                                    })
                                }
                                
                                // 只有发送给第一个联系人的消息才会被保留到历史记录中
                                if (isFristContact) {
                                    await this.$api.sendSysMsg({
                                        msg_type:"图片消息",
                                        msg_cont:fileItem.url
                                    })
                                }
                                await randomDelay1000(); // 延迟 3~5 秒
                            }
                            
                            console.log(`✅ ${contact.wxid} - sendImgMsg 发送成功`);
                        }

                        // 当前联系人全部完成，延迟 3~5 秒再处理下一个联系人
                        if (contact !== contacts[contacts.length - 1]) {
                            console.log(`⏳ 联系人 ${contact.wxid} 完成，等待 3~5 秒进入下一个联系人...`);
                            await randomDelay();
                        }

                    } catch (error) {
                        console.error(`❌ 联系人 ${contact.wxid} 执行失败：`, error);
                        // 可选择继续下一个联系人，或 throw 终止流程
                        // throw error; // 若想中断，取消注释
                    }
                }
                console.log('🎉 所有消息发送完成！');
            }
            
            // 使用选中的联系人发送消息
            try {
                console.log("this.selectedFriends",this.selectedFriends);
                console.log("this.selectedGroupContacts",this.selectedGroupContacts);
                
                // 收集所有需要发送消息的联系人
                let allContactsToSend = [];
                
                // 添加选中的好友
                if (this.selectedFriends.length > 0) {
                    const selectedFriendContacts = this.friendContacts.filter(contact => 
                        this.selectedFriends.includes(contact.wxid)
                    )
                    allContactsToSend = allContactsToSend.concat(selectedFriendContacts);
                }
                
                // 添加选中的群聊
                if (this.selectedGroups.length > 0) {
                    const selectedGroupContacts = this.groupContacts.filter(contact => 
                        this.selectedGroups.includes(contact.wxid)
                    )
                    allContactsToSend = allContactsToSend.concat(selectedGroupContacts);
                }
                
                // 发送消息
                if (!this.shouldStopSending && allContactsToSend.length > 0) {
                    this.sendingText = '正在发送消息...'
                    await sendMessagesToContacts(allContactsToSend);
                }
            } catch (error) {
                console.error('发送消息错误：', error)
            }
            
            // 关闭页面内加载状态
            this.isSending = false
            
            // 根据是否中断来决定后续操作
            if (this.shouldStopSending) {
                // 被中断的情况，直接撤回已发送的消息
                if (this.sentMessages.length > 0) {
                    this.revokeAllMessages()
                } else {
                    this.$warMsg('发送已取消')
                }
            } else {
                // 正常完成，显示成功信息
                this.$suMsg('发送完成')
            }
        },
        
        // 处理联系人选择弹窗关闭
        handleContactSelectorClose(done) {
            this.$confirm('确认关闭联系人选择窗口吗？')
                .then(_ => {
                    done();
                })
                .catch(_ => {});
        },
        
        // 处理取消发送
        handleCancelSending() {
            this.$confirm('确定要取消发送吗？将会中断后续消息并撤回已发送的消息。', '取消发送', {
                confirmButtonText: '确定取消',
                cancelButtonText: '继续发送',
                type: 'warning'
            }).then(() => {
                this.shouldStopSending = true
                this.sendingText = '正在取消发送...'
                console.log('🚫 用户确认取消发送')
            }).catch(() => {
                console.log('🚀 用户选择继续发送')
            })
        },
        
        // 撤回所有已发送的消息
        async revokeAllMessages() {
            const revokeLoading = this.$loading({
                lock: true,
                text: '正在撤回消息...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            
            let successCount = 0
            let failCount = 0
            
            for (const message of this.sentMessages) {
                try {
                    console.log('正在撤回消息:', message)
                    
                    // 调用撤回接口，直接传入message对象
                    await this.$apiGewe.revokeMsg(message)
                    
                    successCount++
                    console.log(`✅ 撤回成功: ${message.toWxid || 'unknown'} - ${message.type}`)
                    
                    // 撤回间隔延迟
                    await new Promise(resolve => setTimeout(resolve, 1000))
                    
                } catch (error) {
                    failCount++
                    console.error(`❌ 撤回失败: ${message.toWxid || 'unknown'} - ${message.type}`, error)
                }
            }
            
            revokeLoading.close()
            
            // 显示撤回结果
            if (failCount === 0) {
                this.$suMsg(`撤回完成！成功撤回 ${successCount} 条消息`)
            } else {
                this.$warMsg(`撤回完成！成功 ${successCount} 条，失败 ${failCount} 条`)
            }
            
            // 清空发送记录
            this.sentMessages = []
        },
        
        handleClick(){
            this.getAllList()
        },
        
        async getAllList(){
            let res= await this.$api.getSysMsgList({
                page:1,
                limit:10
            })
            // this.messageList = res.slice(0,10)
            this.messageList = res.slice(0,10)
        },
        
        fileDel(file,type='imgList'){
            console.log("file",file);
            
            this[type] = this[type].filter(item=>item.url!=file.response.data.url)
        
            console.log("fileList", this[type]);
        },
        
        upImgSuccess(res){
            console.log("res1",res);
            this.imgList.push(res.data)
            this.messageInfo.imgUrl = res.data.url 
        },
        
        upFileSuccess(res,file){
            this.fileList.push({
                ...res.data,
                fileUrl:res.data.url,
                fileName:file.name
            })
        },
    },
    created(){
        this.getAllList()
        console.log("this.getAllList", encodeUrlSafeBase64("测试"));
        // this.$apiGewe.getUserList({})
    },
    props:{
        
    }
}
</script>
<style lang="scss">
.my-message{
    background: #fff;
    padding: 20px;
    position: relative;
    
    // 页面内加载遮罩
    .sending-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
        
        .sending-content {
            text-align: center;
            padding: 40px;
            background: white;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            
            .el-icon-loading {
                font-size: 32px;
                color: #409EFF;
                animation: rotating 1s linear infinite;
            }
            
            p {
                margin: 16px 0;
                font-size: 16px;
                color: #333;
            }
            
            .el-button {
                margin-top: 8px;
            }
        }
    }
    
    // 联系人选择器样式
    .contact-selector {
        .contact-list {
            max-height: 300px;
            overflow-y: auto;
            
            .contact-item {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                padding: 5px 0;
                
                ::v-deep .el-checkbox__input {
                    line-height: 30px;
                    align-self: flex-start;
                }
                
                ::v-deep .el-checkbox__label {
                    width: 100%;
                    padding-left: 10px;
                }
                
                .contact-info {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    
                    .el-avatar {
                        flex-shrink: 0;
                    }
                    
                    .contact-name {
                        margin-left: 10px;
                        flex: 1;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
        
        // 确保折叠面板标题对齐
        .el-collapse-item__header {
            align-items: center;
            
            ::v-deep .el-checkbox {
                display: flex;
                align-items: center;
                height: auto;
                
                .el-checkbox__input {
                    align-self: center;
                }
                
                .el-checkbox__label {
                    padding-left: 8px;
                }
            }
        }
        
        // 确保复选框组正确对齐
        ::v-deep .el-checkbox-group {
            display: block;
        }
    }
    
    .his-list{
        .msg-item{
            border: 1px solid #F5F5F5;
            border-left: none;
            padding: 10px 20px;
            padding-right: 80px;
            box-sizing: border-box;
            position: relative;
            .item-top{
                display: flex;
                .tit{
                    font-size: 16px;
                    margin-right: 10px;
                }
                .time{
                    color: #999;
                }
            }
            .item-body{
                color: #666;
                padding: 10px 0;
                overflow: hidden;
                span{
                    margin-right: 15px;
                }
            }
            .el-button{
                position: absolute;
                top: 26px;
                right: 22px;
            }
        }
    }
}

// loading 旋转动画
@keyframes rotating {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>